export default[
    // {//首页
    //     path: '/',
    //     component: function (resolve) {
    //         require(['./Index.vue'], resolve);
    //     }
    // },
    // {//登录页
    //     path: '/login',
    //     component: function (resolve) {
    //         require(['./Login.vue'], resolve);
    //     }
    // },
    // {
    //     path: '/share',
    //     component: function (resolve) {
    //         require(['./share.vue'], resolve);
    //     }
    // },
    {//AI音乐生成
        path: '/music',
        component: function (resolve) {
            require(['./MusicGen.vue'], resolve);
        }
    },
    {//AI图片生成
        path: '/image',
        component: function (resolve) {
            require(['./ImageGen.vue'], resolve);
        }
    },
    {//AI视频生成
        path: '/video',
        component: function (resolve) {
            require(['./VideoGen.vue'], resolve);
        }
    }
]